import React from "react";

// ============================================================
// Button — Phase 1 button primitive.
// ============================================================
// Wraps the `.btn-{variant}` utility classes defined in
// tokens.css. Colour + typography + shadow behaviour flip
// automatically between light and dark mode via `.dark`
// cascade — this component only picks the class and forwards
// props.
//
// Product rule (enforced by convention): a single page or
// modal should render at most ONE `variant="primary"` button.
//
// variants:
//   primary     → gradient CTA (indigo light / gold dark)
//   secondary   → outline
//   tertiary    → text-only, low-priority (Cancel)
//   destructive → text-only, red (permanent delete)
//   icon        → 36×36 square, elevated background
//
// sizes:
//   default → 10px 20px padding
//   sm      → 6px 12px padding  (primary + secondary only)
// ============================================================

const VARIANT_CLASS = {
  primary: "btn-primary",
  secondary: "btn-secondary",
  tertiary: "btn-tertiary",
  destructive: "btn-destructive",
  icon: "btn-icon",
};

export function Button({
  variant = "primary",
  size = "default",
  type = "button",
  disabled = false,
  onClick,
  className = "",
  children,
  ...rest
}) {
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.primary;
  const sizeClass = size === "sm" && (variant === "primary" || variant === "secondary")
    ? "btn-sm"
    : "";
  const combined = [variantClass, sizeClass, className].filter(Boolean).join(" ");
  return (
    <button
      type={type}
      className={combined}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
}

export default Button;
